import { Injectable, inject } from '@angular/core'
import { Router, ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Injectable({ providedIn: 'root' })
export class CustomLoginGuardClass {
  constructor(
    protected authService: AuthService,
    private userAccountFacade: UserAccountFacade,
    private globalMessageService: GlobalMessageService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    this.authService.isUserLoggedIn().subscribe((res) => {
      if (res) {
        return true
      } else {
        this.globalMessageService.add(
          { key: 'sharedComponents.accessedByLoggedinUser' },
          /* 'Page can only be accessed by logged-in user', */
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        this.router.navigate(['/login'])
        return true
      }
    })
    return true
  }
}
export const CustomLoginGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(CustomLoginGuardClass).canActivate(route)
}
